import React, { useEffect, useRef } from 'react';
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import { title } from 'node:process';

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const SopProductionScheduleAdherence: React.FC = () => {
    const data = {
        labels: ['Dec/2024', 'Jan/2025', 'Feb/2025', 'Mar/2025', 'Apr/2025'],
        datasets: [
         
            {
                label: 'Schedule Adherence',
                data: [85,45,47,40,12],
                backgroundColor: "#90CAF9",
                borderColor: "#90CAF9"
            },
            // Capacity Utilization
            {
                label: 'Capacity Utilization',
                data: [45, 55, 65, 70,85],
                backgroundColor: "#2196F3",
                borderColor: "#2196F3"
            },
        ],
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
       
        plugins: {
          
            tooltip: {
                callbacks: {
                    label: (context: any) => {
                        return `${context.dataset.label}: ${context.raw}%`;
                    },
                },
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { font: { size: 12 } },
            },
            y: {
                ticks: {
                    callback: (value: any) => `${value}%`,
                    font: { size: 12 },
                },
                beginAtZero: true,
            },
        },
    }

    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className="title-card mb-2">KPIs</strong>
            <div style={{ height: '100%' }}>
                <Line data={data} options={options}></Line>
            </div>
        </div>
    );
};

export default SopProductionScheduleAdherence;
